import * as Yup from 'yup'
import { mobileSchema } from './mobile-schema.validation'

const userProfileSchema = Yup.object().shape({
  image: Yup.object().shape({
    icon: Yup.string().nullable(true),
  }),
  name: Yup.string().max(100, 'validation-max-100').nullable(true),
  mobile: mobileSchema,
})

export { userProfileSchema }
